import { render, staticRenderFns } from "./PlatformAccount.vue?vue&type=template&id=5bed7c28&scoped=true&"
import script from "./PlatformAccount.vue?vue&type=script&lang=js&"
export * from "./PlatformAccount.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAccount.vue?vue&type=style&index=0&id=5bed7c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed7c28",
  null
  
)

export default component.exports